import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { H1 } from '../text';
import LayoutContext from '../../contexts/Layout';

const ComponentTitle = ({ style, title, ...rest }) => {
    const { layout } = useContext(LayoutContext);

    return <H1 {...rest} style={{ marginLeft: layout.styleGuide.spacer2, ...style }} text={title} />;
};

ComponentTitle.propTypes = {
    style: PropTypes.object,
    title: PropTypes.string
};

export default ComponentTitle;
